// All the below classes need to stay in sync with the DataCollector equivalents.
// In the future we might want to create a simple shared "Interfaces" package that we can both depend on.

export const baseOutputDirectoryConst: string = "Microsoft\\VSFeedbackCollector";
const feedbackEndpointConst: string = "https://go.microsoft.com/fwlink/?LinkId=689975";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const feedbackEndpointDevConst: string = "https://sendvsfeedback.cloudapp.net/api/fileBlob/blobUploadRequest";
const uploadOutputDirectoryConst: string = "VSfeedback_AzureUpload";
const maxRetriesConst: number = 10;
const requestVersionConst: number = 2;
const resumeFeedbackEndpointConst: string = "https://go.microsoft.com/fwlink/?LinkId=690139";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const resumeFeedbackEndpointDevConst: string = "https://sendvsfeedback.cloudapp.net/api/fileBlob/blobResumeRequest";
export const collectionOutputDirectoryConst: string = "VSFeedback_Collector_";

class UploadConfig {
    public baseOutputDirectory: string = baseOutputDirectoryConst; // Kept for back-compat. Ignored on server; hardcoded to Microsoft\VSFeedbackCollector
    public clientName: string; //  Used for telemetry property "VS.Feedback.ProductName"; e.g. "community-15-preview-3"
    public clientBuild: string; // Used for telemetry property "VS.Feedback.ProductVersion"; e.g. "15.0.25302.0"
    public feedbackEndpoint: string = feedbackEndpointConst; // Kept for back-compat. Ignored on server & hardcoded
    public infoLocalDirectory: string = uploadOutputDirectoryConst; // Kept for back-compat. Ignored on server & hardcoded to VSfeedback_AzureUpload
    public maxRetries: number = maxRetriesConst; // Kept for back-compat. Ignored on server & hardcoded to 10
    public requestVersion: number = requestVersionConst; // Kept for back-compat. Ignored on server & hardcoded to 2
    public resumeFeedbackEndpoint: string = resumeFeedbackEndpointConst; // Kept for back-compat. Ignored on server & hardcoded
}

export class FileUploadConfig {
    // Feedback ID to use for the files being uploaded
    public feedbackId: string;
    // Feedback session ID to use for telemetry
    public feedbackSessionId: string;
    // Opt in for telemetry?
    public dataOptIn: boolean;
    // Product & Upload API configuration
    public uploadConfig: UploadConfig = new UploadConfig();
    // What files should be uploaded immediately
    public files: Array<string> = [];
}

// All the below classes need to stay in sync with the DataCollector equivalents.
// In the future we might want to create a simple shared "Interfaces" package that we can both depend on.
export class DiagnosticsConfig extends FileUploadConfig { // TODO: this whole class is not needed for DevCom2; verify and remove
    // Default output path for all collectors to use if they are not given a collector specific path
    public outputPath: string;
    // Default process IDs for all collectors to use if they are not given a collector specific list
    public processIds: Array<number> = [];
    // IPC port so that we can talk to the Collector after it elevates
    public ipcPort: number;
    // What data collectors should be run
    public collectors: CollectorConfig[] = [];
    // The root folder of the product installation for the product we're collecting data for.
    // For Visual Studio, this should be something like: C:\Program Files (x86)\Microsoft Visual Studio\VS15Preview
    // Used to find where FeedbackCollector.exe is. TODO: Not needed for DevCom2
    public productInstallPath: string;
}

export class CollectorConfig {
    // Valid collector names are “autodump”, “crashmonitor”, “memorydump”, “problemsteprecorder”, "vseventtracelogs"
    public collector: string;
    public config: DataCollectorArguments;
}

class DataCollectorArguments {
    public processIds: Array<number> = [];
    public outputPath: string;
}

// Possible collectors
export class Collectors {
    public static get autodump(): string { return "autodump"; }
    public static get crashmonitor(): string { return "crashmonitor"; }
    public static get memorydump(): string { return "memorydump"; }
    public static get problemsteprecorder(): string { return "problemsteprecorder"; }
    public static get vseventtracelogs(): string { return "vseventtracelogs"; }
}
